"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-quirino": {
    "65e6e7ea": [{
      "hkey": "b89e25d3",
      "slug": "roiata",
      "name": "Roiata",
      "primary": true,
      "skipSearch": false
    }],
    "roiatta": [{
      "hkey": "b89e25d3",
      "slug": "roiata",
      "name": "Roiata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bc3c65c7": [{
      "hkey": "10662a58",
      "slug": "san-quirino",
      "name": "San Quirino",
      "primary": true,
      "skipSearch": false
    }],
    "sospisio": [{
      "hkey": "10662a58",
      "slug": "san-quirino",
      "name": "San Quirino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;